(() => {
  const cards = document.querySelectorAll(".feature-card--text-reveal");

  const measureCard = (card) => {
    const text = card.querySelector(".text");
    if (!text) return;

    // Save inline styles we might overwrite
    const prev = {
      position: text.style.position,
      visibility: text.style.visibility,
      height: text.style.height,
      opacity: text.style.opacity,
      transform: text.style.transform,
      pointerEvents: text.style.pointerEvents,
    };

    // Make it measurable without affecting layout
    text.style.position = "absolute";
    text.style.visibility = "hidden";
    text.style.height = "auto";
    text.style.opacity = "1";
    text.style.transform = "none";
    text.style.pointerEvents = "none";

    const h = Math.ceil(text.getBoundingClientRect().height);
    card.style.setProperty("--reveal-h", `${h}px`);

    // Restore styles
    Object.assign(text.style, prev);
  };

  cards.forEach((card) => {
    measureCard(card);

    // Update if card width changes (responsive)
    const ro = new ResizeObserver(() => measureCard(card));
    ro.observe(card);

    // Optional: if your text/icon fonts load late and change height
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => measureCard(card));
    }
  });
})();
